import Popper from 'popper.js';

window.Popper = Popper;



// WEBPACK FOOTER //
// ./src/include/popper.js